import '../assets/bimi.svg';
import '../assets/logo-black.png';
import '../assets/logo-white.png';
import Header from '../components/header';
import '../css/index.scss';
import '../css/home/adam.scss';

new Header();

// ── Adam teaser ───────────────────────────────────────────────────────────────
// three.js and the brain scene are fetched only when the section gets close, so they stay off the critical path

const ADAM_FONTS = 'https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&display=swap';

const adam = document.querySelector('.h-adam');

function loadAdam() {
    const fonts = document.createElement('link');
    fonts.rel = 'stylesheet';
    fonts.href = ADAM_FONTS;
    document.head.appendChild(fonts);

    import(/* webpackChunkName: "adam-scene" */ '../js/adam/scenes')
        .then(({ initScenes }) => initScenes(adam))
        .catch(() => adam.querySelector('.part-visual').classList.add('no-webgl'));
}

if (adam) {
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            loadAdam();
        }, { rootMargin: '400px 0px' });
        observer.observe(adam);
    } else {
        loadAdam();
    }
}
